import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

export const AtlasIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="trusted-counterparties" {...props} />;
};
